<script setup lang="ts">
import { useSharedState } from '../../composables/useSharedState';
import { AccordionItemProps } from './AccordionItemProps';
import { useAccordion } from './useAccordion';

const props = withDefaults(defineProps<AccordionItemProps>(), {
  open: false,
  disabled: false
});

const state = useSharedState(props);
const accordion = useAccordion();
</script>

<template>
  <div
    class="e-accordion"
    :data-state="accordion.isOpen() ? 'open' : 'closed'"
    :class="[
      `e-accordion-size-${state.size?.value || 'md'}`,
      `e-accordion-color-${state.color?.value || 'primary'}`,
      `e-accordion-variant-${state.variant?.value || 'solid'}`
    ]"
  >
    <slot name="header">
      <e-accordion-header>
        <e-accordion-trigger />
      </e-accordion-header>
    </slot>
    <e-accordion-content v-show="accordion.isOpen()">
      <slot name="content" />
    </e-accordion-content>
  </div>
</template>
